export const SEARCH_TAB_STYLES = {
  button:
    "flex flex-col items-center gap-2 px-1 sm:px-6 rounded-full snap-start shrink-0 border h-auto py-1 relative z-10 min-w-[60px] sm:min-w-[100px] transition-colors duration-300 border-transparent hover:bg-gray-100 text-ticketon-lighter-blue",
  iconWrapper:
    "flex items-center justify-center rounded-xl transition-all duration-300 w-12 h-12 sm:w-9 sm:h-9",
  iconWrapperActive: "bg-orange-dark",
  label:
    "text-[13px] sm:text-[13px] font-medium text-ticketon-dark-blue whitespace-nowrap text-center leading-none",
} as const;
